import {lazy} from "react";

export const UpdateVoyageTemplateLazy = lazy(() => import('./UpdateVoyageTemplate'))
